const titles = document.querySelectorAll('drawer-component .minicart-slider__title svg');

titles.forEach((svg) => {
    svg.addEventListener('click', () => {
        svg.classList.toggle('minicart-slider__svg-active');
        const slider = document.querySelectorAll('drawer-component .minicart-slider__slider')[0];
        if (slider) {
            slider.classList.toggle('minicart-slider__slider-hide');
        }
    });
});

// Move Vtl-VolumeDiscountRadio__TierHighlight into Vtl-VolumeDiscountRadio__LabelHeader
function moveTierHighlightToLabelHeader() {
    const tierHighlights = document.querySelectorAll('.Vtl-NewVolumeDiscountRadio__Label');
    if (!tierHighlights.length) return;
    tierHighlights.forEach((tierHighlight) => {
        const wrapper =
            tierHighlight.closest('.Vtl-NewVolumeDiscountRadio__LabelWrapper') ||
            tierHighlight.closest('.Vtl-NewVolumeDiscountRadio__LabelHeader') ||
            tierHighlight.closest('label');

        if (!wrapper) return;

        const target =
            wrapper.querySelector('.Vtl-NewVolumeDiscountRadio__LabelTitleRow') ||
            wrapper.querySelector('.Vtl-NewVolumeDiscountRadio__LabelHeaderTitle') ||
            wrapper.querySelector('.Vtl-NewVolumeDiscountRadio__LabelHeaderLeft') ||
            wrapper.querySelector('.Vtl-NewVolumeDiscountRadio__LabelHeader');

        if (target && !target.contains(tierHighlight)) {
            target.appendChild(tierHighlight);
        }
    });
}

let moveScheduled = false;
function scheduleMoveTierHighlight() {
    if (moveScheduled) return;
    moveScheduled = true;
    requestAnimationFrame(() => {
        moveScheduled = false;
        moveTierHighlightToLabelHeader();
    });
}

// Run immediately when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleMoveTierHighlight);
} else {
    scheduleMoveTierHighlight();
}

// Also run when new content is added (for dynamic content)
const volumeDiscountObserver = new MutationObserver(() => {
    scheduleMoveTierHighlight();
});

volumeDiscountObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
});

// Extra retries for late-injected widgets (backstop)
setTimeout(scheduleMoveTierHighlight, 250);
setTimeout(scheduleMoveTierHighlight, 1000);
